import {useToNumber, useCheckType, types} from '@sttedra_ui/framework';
import BaseApiModel from '../../_commons/base.api-model';

export default class Tutorial extends BaseApiModel {
  // #region Props
  querySelector;
  skipWithoutElement;
  orientation;
  title;
  text;
  triggerMenuId;
  sidebar;
  // #endregion


  constructor(data) {
    super(data);

    const {
      querySelector,
      skipWithoutElement,
      orientation,
      title,
      text,
      triggerMenuId,
      sidebar,
    } = data;

    this.querySelector = this.#getString(querySelector);
    this.skipWithoutElement = skipWithoutElement;
    this.orientation = this.#getString(orientation);
    this.title = this.#getString(title);
    this.text = this.#getTexts(text);
    this.triggerMenuId = this.#getString(triggerMenuId);
    this.sidebar = this.#getBoolean(sidebar);
  }


  // #region Public methods
  // #endregion


  // #region Private methods
  #getTexts(texts) {
    const textString = this.#getString(texts);
    const textsArray = [];

    if (textString) {
      for (let text of textString.split('\n')) {
        text = text.trimStart();
        text = text.trimEnd();
        textsArray.push(text);
      }
    }
    return textsArray;
  }
  // #endregion

  // #region Private methods
  #getNumber(newValue) {
    const number = useToNumber(newValue);
    return number >= 0 ? number : null;
  }
  #getString(newValue) {
    const expectedType = useCheckType(newValue, types.STRING);
    return expectedType ? newValue : null;
  }
  #getBoolean(newValue) {
    const expectedType = useCheckType(newValue, types.BOOLEAN);
    return expectedType ? newValue : null;
  }
  // #endregion
}
